/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_Settings_Success_Updatedefaultsla2Inputs */

const en_cases_settings_success_updatedefaultsla2 = /** @type {(inputs: Cases_Settings_Success_Updatedefaultsla2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Default triage SLA updated`)
};

/**
* | output |
* | --- |
* | "Default triage SLA updated" |
*
* @param {Cases_Settings_Success_Updatedefaultsla2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cases_settings_success_updatedefaultsla2 = /** @type {((inputs?: Cases_Settings_Success_Updatedefaultsla2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Settings_Success_Updatedefaultsla2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cases_settings_success_updatedefaultsla2(inputs)
});
export { cases_settings_success_updatedefaultsla2 as "cases_settings_success_updateDefaultSla" }